import { ReactNode } from "react";
import { clsx } from "clsx";

export function FullHeightMainContainer({
    children,
    className,
    xCompact,
}: {
    children: ReactNode;
    className?: string;
    xCompact?: boolean;
}) {
    return (
        <div
            className={clsx(
                "grow flex flex-1 flex-col min-h-0 min-w-0 p-6 lg:p-10",
                className,
                xCompact ? "px-3 lg:px-5" : "px-6 lg:px-10",
            )}
        >
            {children}
        </div>
    );
}

export function Container({
    children,
    className,
    xCompact,
}: {
    children: ReactNode;
    className?: string;
    xCompact?: boolean;
}) {
    return (
        <div
            className={clsx(
                "py-6 lg:py-10 overflow-scroll",
                className,
                xCompact ? "px-3 lg:px-5" : "px-6 lg:px-10",
            )}
        >
            {children}
        </div>
    );
}
